import type { GeodeModel } from '../types';

export type { GeodeModel };

export function geodeLayoutFromModel(model: GeodeModel) {
  return {
    cx: model.cx,
    cy: model.cy,
    display: model.displaySize,
    shadow: model.shadow,
    hitRadius: model.hitRadius,
  };
}
